import { Tooltip } from 'antd';
import { Button } from 'antd';
import React from 'react';
import { TbRefresh } from 'react-icons/tb';

interface Props {
  map: L.Map | null;
  buttonText: string;
  tooltipText: string;
  refetchByGeo: () => void;
}

const FetchMoreButton: React.FC<Props> = ({ map, buttonText, tooltipText, refetchByGeo }) => {
  return (
    <div className='fetch-more-button-wrapper'>
      <Tooltip title={tooltipText} placement='bottom'>
        <Button
          type="ghost"
          className="icon-btn"
          onClick={() => refetchByGeo()}
          icon={<TbRefresh size={16} />}
        >
          {buttonText}
        </Button>
      </Tooltip>
    </div>
  );
};

export default FetchMoreButton;
